import SeenThings from '@Components/Modals/SeenThings/SeenThings';
import { useSeenThingsPresenter } from '@Components/Modals/SeenThings/SeenThingsPresenter';
import { isMobile } from '@Constants/LeftDrawer';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import styled from 'styled-components/native';

const StyledWrapperView = styled.Pressable`
  position: absolute;
  right: ${isMobile ? '11px' : '28px'};
  top: 75px;
  cursor: default;
  width: ${isMobile ? 'calc(100% - 22px)' : '620px'};
  border-radius: 30px;
  box-shadow: 0 0 25px ${OwnableTheme.colors.modalShadow};
  background-color: white;
`;

const StyledPressable = styled.Pressable`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${OwnableTheme.colors.modalShadowDark};
  backdrop-filter: blur(6px);
`;

const SeenThingsPanel = () => {
  const { hide } = useSeenThingsPresenter();

  return (
    <StyledPressable
      onPress={() => {
        hide();
      }}
    >
      <StyledWrapperView
        onPress={(e) => {
          e.stopPropagation();
        }}
      >
        <SeenThings />
      </StyledWrapperView>
    </StyledPressable>
  );
};

export default observer(SeenThingsPanel);
